import { useWorkspaceInfoContext } from './useWorkspaceInfoContext';

export function useWorkspaceInfo() {
  const workspace = useWorkspaceInfoContext((s) => s.workspace);

  return { workspace };
}
